<!-- "components tags" are not recognised by the Browser, so it sets the default display value = 'inline' for the host element -->
<!-- in order to solve height issues, we set the component's main div display: block -->
<div *ngIf="!showBo" style="display: block; height: 100%; width: 100%; text-align: center">
  <div class="fa-3x">
    <i class="fas fa-spinner fa-pulse fa-spin q-c-main"></i>
  </div>
</div>

<div *ngIf="showBo" id="boL1" class="container-fluid h-100" style="display: block; height: 100%; width: 100%;">
  <div class="row no-gutters">      
    <button type="button" *ngIf="statusAdmin && modeBo ===modeBoEnum.Edit " class="btn adminBtn col-auto" (click)="openAdmin()" title="Ouvrir l'administration du BO (ident: {{model?.IdDonneeFils}})">
      <i class="fas fa-cog"></i>
    </button>
    <button type="button" *ngFor="let btn of model.Header.ButtonsList" class="col-auto" [ngClass]="setClassBtn(btn)" (click)="action(btn)" title="{{btn.ToolTip}}">
      <i [class]="setClassBtnImg(btn)"></i>
    </button>
    <q-saved-models class="col-auto ml-auto" [model]="model" (modelChange)="OnModelChange($event)"></q-saved-models>
  </div>



    <div class="row no-gutters h-100 overflow-auto" [ngStyle]="styleCustomBo">

      <ng-container *ngFor="let item of model.Body.SelectedGroupsList">
        <div class="col">
          <div *ngIf="item.template && item.showTpl && modeBo == modeBoEnum.Edit" class="templateWrapper">
            <div col="row " (click)="item.showTpl = false">
              <div class="col-12 p-0">
                <h5 class="q-bo-grouptitle">{{item.Legend}}</h5>
              </div>
            </div>
            <div [style.height.px]="item.tplY" [style.width.px]="item.tplX" style="overflow:auto;"> <ng-container *ngComponentOutlet="template[item.template]; injector: injectorTemplate"></ng-container></div>
          </div>

          <q-dynamic-tag-group *ngIf="!item.showTpl || !item.template ||  modeBo != modeBoEnum.Edit" class="w-100" [ModeBo]="modeBo" [Model]="model" [item]="item.DataList" [title]="item.Legend" [parent]="groupContainer" (sendBreadcrumb)="getBreadcrump($event)" [itemGrp]="item"></q-dynamic-tag-group>

        </div>
      </ng-container>

    </div>
  </div>


  <!--#region modal confirmation delete -->

  <q-modal id="deleteModal" [width]="'col-10 col-md-5 col-ls-4 col-xl-3'" [height]="'auto'" (close)="closeDeleteModal()">
    <div class="row no-gutters pt-4 justify-content-center">
      <p>{{'deleteQuestion' | trad}}</p>
    </div>
    <div class="row no-gutters pb-4 mt-4 align-items-center">
      <div class="row col-10 col-sm-8 offset-1 offset-sm-2 h-100 p-0 justify-content-between">
        <button class="btn btn-success" (click)="delete()">{{'valid' | trad}}<i class="fas fa-check ml-2"></i></button>
        <button class="btn btn-danger" (click)="closeDeleteModal()">{{'no' | trad}}<i class="fas fa-times ml-2"></i> </button>
      </div>
    </div>
  </q-modal>

  <!--#endregion modal confirmation delete -->
  <!--#region BO Administration -->

  <q-dragmodal [id]="boDragModalId+model?.IdentBO" [options]="boDragOptions">

    <div class="content-fluid" *ngIf="dragContentShow">
      <div class="row">
        <div class="col-12">
          <q-adminbodata [IdentBO]="model?.IdentBO"></q-adminbodata>
        </div>
      </div>
    </div>

  </q-dragmodal>

  <!--#endregion first-dragmodal-content -->
